import {NgModule} from "@angular/core";
import {ContactComponent} from "./contact.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ContactRoutingModule} from "./contact.routing";

@NgModule({
  declarations: [
    ContactComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ContactRoutingModule
  ],
  exports: [
    ContactComponent
  ],
  providers: []
})

export class ContactModule {}



// WEBPACK FOOTER //
// ./src/app/contact/contact.module.ts